import PropTypes from 'prop-types';
import { Children, isValidElement } from 'react';

import useExpandCustomProtocol from '@core/hooks/useExpandCustomProtocol';
import TutorialTileWrapper from '@routes/Tutorials/components/Tile/Wrapper';

/**
 * Custom components passed to the RDMD engine.
 */

const LinkWrapper = ({ attributes: attr = { target: '_self' }, children, href, ...props }) => {
  const [linkProps, Tag] = useExpandCustomProtocol(href);

  // Unwrap any nested anchor elements that GFM's autolinker may have created.
  // This prevents invalid nested <a> tags when the Anchor's text content looks like a URL.
  // Note: child.type may be 'a' (native) or LinkWrapper (when overridden)
  const unwrappedChildren = Children.map(children, child => {
    if (isValidElement(child) && (child.type === 'a' || child.type === LinkWrapper)) {
      return child.props.children;
    }
    return child;
  });

  return (
    <Tag
      {...{
        ...attr,
        ...linkProps,
        ...props,
        children: unwrappedChildren,
      }}
    />
  );
};
LinkWrapper.propTypes = {
  attributes: PropTypes.object,
  href: PropTypes.string,
};

/**
 * Component-to-block name mapping.
 */
export default {
  Anchor: LinkWrapper,
  a: LinkWrapper,
  'tutorial-tile': TutorialTileWrapper,
  TutorialTile: TutorialTileWrapper,
  Recipe: TutorialTileWrapper,
};
